export const updateLocationDetailItemId = (newId) => {
  const url = new URL(window.location.href)
  const currentDetailId = url.searchParams.get('detail_item_id')
  if (`${currentDetailId}` === `${newId}`) {
    return
  }

  url.searchParams.set('detail_item_id', newId)
  const nextUrl = `${url.pathname}?${url.searchParams.toString()}`
  window.history.replaceState({}, '', nextUrl)
  window.dispatchEvent(new PopStateEvent('popstate'))
}

export const calendlyEventMutation = async ({
  payload,
  candidateId,
  coachId,
  serviceRequestId,
  requestType,
  currentCandidateRevisionId,
  meetingFormatChanged = false,
}) => {
  const calendlyId = payload.event.uri.split('/').pop()
  const calendlyUserId = payload.invitee.uri.split('/').pop()
  const data = {
    request_format: 'json',
    calendly_event: {
      candidate_id: candidateId,
      coach_id: coachId,
      calendly_id: calendlyId,
      calendly_user_id: calendlyUserId,
      service_request_id: serviceRequestId,
      service_request_type: requestType || 'ServiceRequest::ResumeReview',
      service_request_revision_id: currentCandidateRevisionId,
      meeting_format_changed: meetingFormatChanged,
      service_request_data: {
        coach_started: true,
      },
    },
  }

  const csrfToken = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute('content')
  const response = await fetch('/calendly_events.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(csrfToken ? { 'X-CSRF-Token': csrfToken } : {}),
    },
    body: JSON.stringify(data),
    credentials: 'include',
  })
  if (!response.ok) throw new Error('Failed to update meeting')
  return await response.json()
}
